import { h, Component } from 'preact';
import 'store/bolt/cookies';
import 'store/bolt/externalLinkModal';
import Store from 'store/store';
import { joinClasses } from 'utils/utils';

import Button from 'components/bolt/button/button';
import HTML from 'components/core/html/html';
import ExitPage from 'components/bolt/icons/exitPage';

import s from 'components/bolt/externalLinkModal/externalLinkModal.sss';

export default class ExternalLinkModal extends Component {
	constructor(props) {
		super(props);
		this.clickInterceptor = this.clickInterceptor.bind(this);
		this.closeModal = this.closeModal.bind(this);
		this.onClick = this.onClick.bind(this);
	}

	componentDidMount() {
		document.addEventListener('click', this.clickInterceptor, true);
	}
	componentWillUnmount() {
		document.removeEventListener('click', this.clickInterceptor, true);
	}

	componentDidUpdate(prevProps) {
		if (this.props.externalLinkModal?.open && !prevProps.externalLinkModal?.open) {
			this.previousFocus = document.activeElement;
			this.base.querySelector(':is(a,button,input):not([disabled])')?.focus();
		} else if (!this.props.externalLinkModal?.open && prevProps.externalLinkModal?.open) {
			this.previousFocus?.focus();
		}
	}

	clickInterceptor(e) {
		if (!e?.target || this.props.externalLinkModal?.open) {
			return;
		}
		let link = e.target.closest('a, area');
		let linkHref = link?.href;

		if (!linkHref || link.origin === location.origin) {
			return;
		}
		let settings = this.props.appData?.options?.externalLinkModal;
		let urlsWanted = settings?.onlyForUrls?.split('\n').map(str => str.trim());
		if (urlsWanted && !urlsWanted.includes(linkHref)) {
			return;
		}
		let whitelist = settings?.whitelistedDomains?.split('\n').map(str => str.trim());
		if (whitelist && whitelist.includes(link?.hostname)) {
			return;
		}
		Store.emit('DISPLAY_EXTERNAL_LINK_MODAL', {
			originalEvent: e,
			onClick: link.onClick,
			target: link.target,
			href: link.href
		});
		e.stopPropagation();
		e.preventDefault();
	}

	onClick(evt) {
		let { onClick, originalEvent } = this.props.externalLinkModal || {};

		this.closeModal();
		if (onClick && typeof onClick === 'function') {
			return onClick(originalEvent || evt);
		}
	}

	closeModal() {
		Store.emit('HIDE_EXTERNAL_LINK_MODAL');
	}

	renderContent() {
		let { $EXTERNAL_LINK_MODAL_BODY = 'You are leaving this website' } = this.props.copy.baseCopy;
		return (
			<HTML class={s.content} content={$EXTERNAL_LINK_MODAL_BODY} markdown key="content" />
		);
	}

	renderCancel() {
		let { $EXTERNAL_LINK_MODAL_CANCEL = 'Cancel' } = this.props.copy.baseCopy;
		return <Button class={joinClasses(s.button, s.cancel)} type="outlined" trigger={this.closeModal}>{$EXTERNAL_LINK_MODAL_CANCEL}</Button>;
	}

	renderContinue() {
		const externalLinkModal = this.props.externalLinkModal;
		let { $EXTERNAL_LINK_MODAL_OK = 'OK' } = this.props.copy.baseCopy;
		return (
			<Button
				class={s.button}
				type="primary"
				href={externalLinkModal.href}
				target={externalLinkModal.target}
				trigger={this.onClick}
			>
				{$EXTERNAL_LINK_MODAL_OK}
			</Button>
		);
	}

	render(props) {
		const externalLinkModal = props.externalLinkModal;
		if (!externalLinkModal?.open) {
			return <div />;
		}

		return (
			<div class={s.overlay} onClick={this.closeModal}>
				<div class={s.container} onClick={e => e.stopPropagation()}>
					<ExitPage class={s.icon} key="exit" />
					{this.renderContent()}

					<div class={s.buttons} key="buttons">
						{this.renderCancel()}
						{this.renderContinue()}
					</div>
				</div>
			</div>
		);
	}
}
